import * as React from 'react';
import moment from 'moment';
import { Wrapper } from "./style";
import Section from "./Section";
import sections from "./sections";
import SectionBuilder from "./SectionBuilder";
import EducationSummarySection from "./EducationSummarySection";
import SchoolsAttendedSection from "./SchoolsAttendedSection";
function getApplicationState(application) {
  var status = application.status,
    paid = application.paid;
  if (status.readyForVisa) {
    return 'ready for visa';
  }
  if (status.accepted) {
    return 'accepted';
  }
  if (status.rejected) {
    return 'rejected';
  }
  if (status.submitted) {
    return 'submitted';
  }
  if (status.readyToSubmit) {
    return 'ready to submit';
  }
  if (status.canceled) {
    return 'cancelled';
  }
  if (status.withdrawn) {
    return 'withdrawn';
  }
  if (paid) {
    return 'paid';
  }
  return 'unpaid';
}
var ApplicationSnapshot = function ApplicationSnapshot(_ref) {
  var snapshot = _ref.snapshot,
    onCommit = _ref.onCommit,
    committedKeys = _ref.committedKeys,
    currentSnapshot = _ref.currentSnapshot;
  var personalDetailSectionKeys = sections['Personal Info'];
  var addressDetailSectionKeys = sections['Address Detail'];
  var backgroundInformationSectionKeys = sections['Background Info'];
  var testScoresSectionKeys = sections['Test Scores'];
  var greSectionKeys = sections.GRE;
  var gmatSectionKeys = sections.GMAT;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Section, {
    title: "Application Status",
    columns: 1
  }, "This snapshot of the application was created on", ' ', moment(snapshot.programApplication.createdAt).format('dddd, MMMM Do YYYY, h:mm:ss a'), ". At that point, the application was ", getApplicationState(snapshot.programApplication), "."), /*#__PURE__*/React.createElement(SectionBuilder, {
    title: "Personal Info",
    sectionKeys: personalDetailSectionKeys,
    snapshot: snapshot,
    currentSnapshot: currentSnapshot,
    onCommit: onCommit,
    committedKeys: committedKeys
  }), /*#__PURE__*/React.createElement(SectionBuilder, {
    title: "Address Detail",
    sectionKeys: addressDetailSectionKeys,
    snapshot: snapshot,
    currentSnapshot: currentSnapshot,
    onCommit: onCommit,
    committedKeys: committedKeys
  }), /*#__PURE__*/React.createElement(EducationSummarySection, {
    snapshot: snapshot,
    currentSnapshot: currentSnapshot,
    onCommit: onCommit,
    committedKeys: committedKeys
  }), /*#__PURE__*/React.createElement(SchoolsAttendedSection, {
    snapshot: snapshot,
    currentSnapshot: currentSnapshot,
    onCommit: onCommit,
    committedKeys: committedKeys
  }), /*#__PURE__*/React.createElement(SectionBuilder, {
    title: "Test Scores",
    sectionKeys: testScoresSectionKeys,
    snapshot: snapshot,
    currentSnapshot: currentSnapshot,
    onCommit: onCommit,
    committedKeys: committedKeys,
    columns: 2
  }), /*#__PURE__*/React.createElement(Section, {
    title: "Additional Qualifications",
    columns: 1
  }, /*#__PURE__*/React.createElement(SectionBuilder, {
    title: "GRE",
    sectionKeys: greSectionKeys,
    snapshot: snapshot,
    currentSnapshot: currentSnapshot,
    onCommit: onCommit,
    committedKeys: committedKeys,
    columns: 2
  }), /*#__PURE__*/React.createElement(SectionBuilder, {
    title: "GMAT",
    sectionKeys: gmatSectionKeys,
    snapshot: snapshot,
    currentSnapshot: currentSnapshot,
    onCommit: onCommit,
    committedKeys: committedKeys,
    columns: 2
  })), /*#__PURE__*/React.createElement(SectionBuilder, {
    title: "Background Info",
    columns: 1,
    sectionKeys: backgroundInformationSectionKeys,
    snapshot: snapshot,
    currentSnapshot: currentSnapshot,
    onCommit: onCommit,
    committedKeys: committedKeys
  }));
};
export default /*#__PURE__*/React.memo(ApplicationSnapshot);